import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-weight-bold my-1"
}
const _hoisted_2 = { key: 1 }

import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import i18n from '@/lang/i18n';

type headerType = {
  isTitle: boolean,
  keyName: string,
  labelPath: string,
  class: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableHeader',
  props: {
    headers: {},
    deliveryPlan: {}
  },
  setup(__props: any) {

const props = __props;

function labelOrValue(header: headerType) {
  if (!header.labelPath && props.deliveryPlan) {
    return props.deliveryPlan[header.keyName]
  }
  return i18n.global.t(header.labelPath)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header) => {
        return (_openBlock(), _createElementBlock("th", {
          key: header,
          class: _normalizeClass(header.class)
        }, [
          (header.isTitle)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_unref(i18n).global.t(header.labelPath)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(labelOrValue(header)), 1))
        ], 2))
      }), 128))
    ])
  ]))
}
}

})